"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const get_value_form_1 = require("@App/helpers/get-value-form");
const entities_validators_1 = require("@App/helpers/work-entities/entities-validators");
const contexts_1 = require("@App/contexts");
const mobx_react_1 = require("mobx-react");
const RadioSelectionTab_1 = __importDefault(require("@Components/WorkRegistrationSubs/AddWriter/RadioSelectionTab"));
const WriterAfterFindForm_1 = __importDefault(require("@Components/WorkRegistrationSubs/AddWriter/WriterAfterFindForm"));
const WriterCreateSubForm_1 = __importDefault(require("@Components/WorkRegistrationSubs/AddWriter/WriterCreateForm/WriterCreateSubForm"));
const WriterCreateForm = ({ writerData, setWriterData, addWriterToDraft, onRadioButtonClicked, expanded, setFoundWriterToDraft, }) => {
    const [validations, setValidation] = (0, react_1.useState)({
        firstName: {
            maxLength: 60,
            error: '',
            required: false,
        },
        lastName: {
            required: true,
            maxLength: 200,
            error: '',
        },
        roleCode: {
            maxLength: 60,
            error: '',
            required: true,
        },
        ipiNumber: {
            isIPI: true,
            maxLength: 11,
            error: '',
            required: false,
        },
    });
    const [showWriterWasFoundForm, setShowWriterWasFoundForm] = (0, react_1.useState)(false);
    const [isDisabled, setIsDisabled] = (0, react_1.useState)();
    const { writerSearchStore, preloaderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const getValues = (value, id) => {
        const data = (0, get_value_form_1.getValueForm)(value, id, writerData, validations);
        setValidation(data.validationObject);
        setIsDisabled((0, entities_validators_1.formFieldsInvalidCheck)(data.formObject, data.validationObject));
        setWriterData(Object.assign({}, data.formObject));
    };
    const { firstName, lastName, ipiNumber, roleCode } = writerData;
    const checkCreatingWriter = (closePopup) => __awaiter(void 0, void 0, void 0, function* () {
        preloaderStore.openTransparentPreloader(true);
        const searchObj = {
            fullName: `${firstName} ${lastName}`,
            ipiNameNumber: ipiNumber !== null && ipiNumber !== void 0 ? ipiNumber : undefined,
        };
        writerSearchStore.setWriterSearch(searchObj);
        yield writerSearchStore.searchWriters();
        if (writerSearchStore.isThereSearchResults) {
            setShowWriterWasFoundForm(closePopup ? true : 'remainOpen');
            preloaderStore.openTransparentPreloader(false);
            return;
        }
        doAddWriterToDraft(closePopup);
        preloaderStore.openTransparentPreloader(false);
    });
    const doAddWriterToDraft = (closePopup) => {
        addWriterToDraft(closePopup);
        if (!closePopup) {
            setShowWriterWasFoundForm(false);
        }
    };
    const doSetWriterToDraft = (writer, closePopup) => __awaiter(void 0, void 0, void 0, function* () {
        yield setFoundWriterToDraft(Object.assign(Object.assign({}, writer), { roleCode }), closePopup);
        if (!closePopup) {
            setShowWriterWasFoundForm(false);
        }
    });
    (0, react_1.useEffect)(() => {
        setIsDisabled((0, entities_validators_1.formFieldsInvalidCheck)(writerData, validations));
        getValues(firstName, 'firstName');
    }, []);
    (0, react_1.useEffect)(() => {
        setIsDisabled((0, entities_validators_1.formFieldsInvalidCheck)(writerData, validations));
    }, [writerData]);
    return (react_1.default.createElement(RadioSelectionTab_1.default, { id: 'create-writer-tab', name: 'Create a writer', subTitle: !showWriterWasFoundForm
            ? 'If you use only one name or a pseudonym for your writer name, enter that name in the Last Name field and leave the First Name field blank.'
            : undefined, onClick: onRadioButtonClicked, forceChecked: expanded }, expanded && (react_1.default.createElement(react_1.default.Fragment, null, !showWriterWasFoundForm ? (react_1.default.createElement(WriterCreateSubForm_1.default, { firstName: firstName, lastName: lastName, ipiNumber: ipiNumber, roleCode: roleCode, validations: validations, getValues: getValues, onClick: checkCreatingWriter, buttonsDisabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : false })) : (react_1.default.createElement(WriterAfterFindForm_1.default, { changeFormTo: () => {
            setShowWriterWasFoundForm(false);
        }, setFoundWriterToDraft: (foundWriter) => doSetWriterToDraft(foundWriter, showWriterWasFoundForm !== 'remainOpen'), addWriterToDraft: () => doAddWriterToDraft(showWriterWasFoundForm !== 'remainOpen') }))))));
};
exports.default = (0, mobx_react_1.observer)(WriterCreateForm);
